import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=4bb4d804&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=4bb4d804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4d804",
  null
  
)

export default component.exports